module.exports = __webpack_public_path__ + "img/s2-4.6af2508e.jpg";